import video from '../../img/Family.png';
import './About.css';
function About() {
  return (
  <>
    {/* <div className='home'>
      <img className='ok' src={mainimg} ></img>
    </div> */}
  {/* <div className='man'>
  <div class="person">
      <div class="container">
        <div class="container-inner">
          <img
            class=""
          
          />
        </div>
      </div>
      
    </div>

  </div> */}

        <section className='about_section'>
          <img src={video} alt="Video" />
          <div>
            <h1>About Pooja</h1>
            <p>
            Plastic are fast replacing metals everywhere. POOJA PRODUCTS ever since it's inception has strived to provide furniture & households with superior quality plastic products that are not only strong and durable but also beauitiful and elegant. Every POOJA PRODUCTS is designed by experts and available in suitable sizes and a varity of colours. Our beautifully designed products make everyone feel that POOJA PRODUCTS are not just plastic Products but are really lifestyle products. In market crowed with plastic products ours is truly a brand. A brand that does not just supply quality products but caters to all needs and requirements. We have a wide range of products, from moulded furniture to household items, from kitchen containers to fancy articles and even garden planters, to cater to every household requirement.
            </p>
          
          </div>
        </section>
        <section className='strip'>
          <h3></h3>
          <div className='para'>
            <p>
            We make every corner of Your house/office colourful with magic of Plastic, Our products are not just made with Plastic but are made with addition of Love.
            </p>
          </div>
        </section>
  </>
  )
}

export default About